var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlertCircleBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9422_57205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28101 14C11.5947 14 14.281 11.3137 14.281 8C14.281 4.68629 11.5947 2 8.28101 2C4.9673 2 2.28101 4.68629 2.28101 8C2.28101 11.3137 4.9673 14 8.28101 14ZM8.28101 15C12.147 15 15.281 11.866 15.281 8C15.281 4.13401 12.147 1 8.28101 1C4.41501 1 1.28101 4.13401 1.28101 8C1.28101 11.866 4.41501 15 8.28101 15Z",
    fill: "#3A61EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28102 7.36365C8.63247 7.36365 8.91738 7.64856 8.91738 8.00001V10.5455C8.91738 10.8969 8.63247 11.1818 8.28102 11.1818C7.92956 11.1818 7.64465 10.8969 7.64465 10.5455V8.00001C7.64465 7.64856 7.92956 7.36365 8.28102 7.36365Z",
    fill: "#3A61EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64465 5.4546C7.64465 5.10315 7.92956 4.81824 8.28102 4.81824H8.2895C8.64096 4.81824 8.92587 5.10315 8.92587 5.4546C8.92587 5.80605 8.64096 6.09096 8.2895 6.09096H8.28102C7.92956 6.09096 7.64465 5.80605 7.64465 5.4546Z",
    fill: "#3A61EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9422_57205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1.28101 1)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertCircleBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/AlertCircleBlue.261ec341.svg";
export { ForwardRef as ReactComponent };